import { render, staticRenderFns } from "./ModalAddEdit.vue?vue&type=template&id=23568b63&scoped=true&"
import script from "./ModalAddEdit.vue?vue&type=script&lang=js&"
export * from "./ModalAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddEdit.vue?vue&type=style&index=0&id=23568b63&scoped=true&lang=css&"
import style1 from "./ModalAddEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23568b63",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDatePicker,VMenu,VRadio,VRadioGroup,VRow,VSelect,VSnackbar,VSwitch,VTextField})
